import buyFA from './fa/fa.json'

const BuyMessages = {
  fa: { ...buyFA },
}

export default BuyMessages
